// src/components/layout.js

/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.com/docs/how-to/querying-data/use-static-query/
 */

import * as React from "react"
import Navigation from "./navigation"
import Footer from "./footer"
import { Script } from "gatsby" // Keep this import

const Layout = ({ children }) => {
  return (
    <div className="flex flex-col min-h-screen bg-white">
      {/* Fathom Analytics Script */}
      <Script
        src="https://cdn.usefathom.com/script.js"
        data-spa="auto" // Fathom's specific attribute for SPA handling
        data-site="LETGOGZR" // Your Fathom site ID
        strategy="idle"     // Recommended for analytics: loads when the browser is idle
      />

      <Navigation />
      <div className="flex-1">
        <main>{children}</main>
      </div>
      <Footer />
    </div>
  )
}

export default Layout